import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { Suspense } from 'react';
import { useParams } from 'react-router';
import { useSessionsEntry } from '../Components/useSessionsEntry';
import { Sessions } from './Sessions';
import { ControlPanel } from 'common/components/Graphs/ControlPanel';
import { GraphSessionRangeProvider } from 'common/components/Graphs/Sessions/GraphSessionRangeProvider';
import { ScrollArea } from 'src/common/components/ScrollArea/ScrollArea';
import { styled } from '@mui/material/styles';
import { TabPanelWithErrorHandling } from 'src/common/components/AppLayout/Components/TabPanelWithErrorHandling';
import { useTranslation } from 'react-i18next';
import { ErrorCodes } from 'src/common/responseCodes';

const HistoryAnalysisContentRoot = styled('div', { name: 'HistoryAnalysisContentRoot' })({
  position: 'relative',
  height: '100%',
  width: '100%',
});

const HistoryAnalysisContent = () => {
  const { iccid } = useParams();

  const { data: sessionEntry } = useSessionsEntry(iccid!);

  return (
    <HistoryAnalysisContentRoot>
      <GraphSessionRangeProvider>
        <ScrollArea style={{ height: '100%' }}>
          <Box
            sx={{
              height: '100%',
              pt: 8,
            }}
          >
            <Box
              sx={{
                pt: 8,
                pb: 8,
                px: 16,
                borderBottom: (theme) => `1px solid ${theme.palette.border}`,
              }}
            >
              <ControlPanel
                sliderSx={{
                  px: 24,
                }}
              />
            </Box>
            <Box
              sx={{
                pt: 8,
              }}
            >
              <Sessions imsi={sessionEntry?.imsi || ''} />
            </Box>
          </Box>
        </ScrollArea>
      </GraphSessionRangeProvider>
    </HistoryAnalysisContentRoot>
  );
};

const IGNORED_ERRORS = [ErrorCodes.NotFound];
export const HistoryAnalysis = () => {
  const { t } = useTranslation();
  return (
    <TabPanelWithErrorHandling
      name={t('simInventory.details.tabs.historyAnalysis')}
      ignoreErrorMessages={IGNORED_ERRORS}
    >
      <Suspense
        fallback={
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              height: '100%',
            }}
          >
            <CircularProgress />
          </Box>
        }
      >
        <HistoryAnalysisContent />
      </Suspense>
    </TabPanelWithErrorHandling>
  );
};
